// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAzFS-SSozevE2tRb5FumLnF1n88fZcPuA",
  authDomain: "erickthedev-3d55a.firebaseapp.com",
  projectId: "erickthedev-3d55a",
  storageBucket: "erickthedev-3d55a.firebasestorage.app",
  messagingSenderId: "117585111388",
  appId: "1:117585111388:web:2ae64cba00245104a37999",
  measurementId: "G-4B0WDVP4CW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);